import { instance } from "api/apiBase";
import { BankAccount } from "types/billing";

const api = {
  getBankAccounts: async () => {
    return (await instance.get("/portal/v1/bank_accounts")).data;
  },
  postBankAccounts: async (data: {
    bank_account: BankAccount;
    usage_kinds: ("payout" | "invoice")[];
  }) => {
    return (await instance.post("/portal/v1/bank_accounts", data)).data;
  },
  setPayoutBankAccount: async (data) => {
    return (
      await instance.post(
        `/portal/v1/bank_accounts/${data.id}/set_payout_bank_account`,
        data
      )
    ).data;
  },
  setInvoiceBankAccount: async (data) => {
    return (
      await instance.post(
        `/portal/v1/bank_accounts/${data.id}/set_invoice_bank_account`,
        data
      )
    ).data;
  }
};

export default api;
